import React, { useEffect, useState } from "react";
import CollapsibleTable from "../CollapsibleTable/CollapsibleTable";
import SinglePage from "../PdfViewer/PdfViewer";
import "./InitialCaseDetails.css";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import CloseIcon from "@mui/icons-material/Close";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import DoneIcon from "@mui/icons-material/Done";
import { useParams } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { URL } from "../../constants/constant";

var axios = require("axios");

const InitialCaseDetails = () => {
  let { caseId } = useParams();
  let [digitisationResults, setDigitisationResults] = useState([]);
  let [name, setName] = useState("");
  let [labname, setLabName] = useState("");
  let [age, setAge] = useState("");
  let [Gender, setGender] = useState("");
  let [state, setState] = useState("");
  let [doctorName, setDoctorName] = useState("");
  let [registrationNum, setRegistrationNum] = useState("");
  let [declarationAvailable, setDeclarationAvailable] = useState("");
  let [Qualification, setQualification] = useState("");
  let [photo, setPhoto] = useState("");
  let [apptDate, setApptDate] = useState("");
  let [comment, setComment] = useState("");
  let [testList, setTestList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openIncompleteDialog, setOpenIncompleteDialog] = React.useState(false);
  let [incompleteComments, setIncompleteComments] = useState("");
  const [openRejectedDialog, setOpenRejectedDialog] = React.useState(false);
  let [rejectedCommentsVal, setRejectedComments] = useState("");
  const [openVerifiedDialog, setOpenVerifiedDialog] = React.useState(false);
  const [base64String, setBase64String] = useState("");
  const [keyToDownload, setKeyToDownload] = useState("");
  const [testPage, setTestPage] = useState(1);
  const [preSignedUrl, setPreSignedUrl] = useState('');
  let [procheckComment, setProcheckComment] = useState("");
  const [reportFileType, setReportFileType] = useState('');

  let [lisFlag, setLisFlag] = useState(false);

  const handleIncompleteClickOpen = () => {
    setOpenIncompleteDialog(true);
  };

  const handleIncompleteClose = () => {
    setOpenIncompleteDialog(false);
  };

  const handleRejectedClickOpen = () => {
    setOpenRejectedDialog(true);
  };

  const handleRejectedClose = () => {
    setOpenRejectedDialog(false);
  };

  const handleIncomplete = () => {
    console.log("incomplete");

    //call status change api here to change status to incomplete

    var data = JSON.stringify({
      case_id: caseId,
      state: "INCOMPLETE",
      remarks: incompleteComments,
    });

    if (!incompleteComments) {
      alert("Please pass comments");
      return;
    }
 
    var config = {
      method: "post",
      url: URL.demystify_url + "basicCaseData/update-status-v2/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    //   axios(config)
    //   .then(function (response) {
    //     console.log(JSON.stringify(response.data));
    //   })
    //   .catch(function (error) {
    //     alert(error)
    //     console.log(error);
    //   });

    setOpenIncompleteDialog(false);
  };

  const handleRejected = () => {
    console.log("rejected");

    //call status change api here to change status to rejected

    var data = JSON.stringify({
      case_id: caseId,
      state: "REJECTED",
      remarks: rejectedCommentsVal,
    });

    if (!rejectedCommentsVal) {
      alert("Please pass comments");
      return;
    }

    //   var config = {
    //     method: 'post',
    //     url: URL.demystify_url + 'basicCaseData/update-status/',
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     data : data
    //   };

    //   axios(config)
    //   .then(function (response) {
    //     console.log(JSON.stringify(response.data));
    //   })
    //   .catch(function (error) {
    //     alert(error)
    //     console.log(error);
    //   });

    setOpenRejectedDialog(false);
  };

  const handleVerifiedClose = () => {
    setOpenVerifiedDialog(false);
  };

  const handleVerifiedOpen = () => {
    setOpenVerifiedDialog(true);
  };

  const handleVerified = () => {
    //call status change api here to change status to verified

    //  var data = JSON.stringify({
    //     "case_id": caseId,
    //     "state": "VERIFIED",
    //     "remarks": "verified"
    //   });

    //   var config = {
    //     method: 'post',
    //     url: URL.demystify_url + 'basicCaseData/update-status/',
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     data : data
    //   };

    //   axios(config)
    //   .then(function (response) {
    //     console.log(JSON.stringify(response.data));
    //   })
    //   .catch(function (error) {
    //     alert(error)
    //     console.log(error);
    //   });

    setOpenVerifiedDialog(false);
  };

  const handleEdit = () => {
    alert("Not yet implemented");
    console.log("edit");
  };

  const handlePageChange = (page) => {
    setTestPage(page);
  };

  const [rows, setRows] = useState([]); //set parents state from here
  const [rows2, setRows2] = useState([]);
  useEffect(() => {
    console.log("caseIdComp: " + caseId);

    //call api here to fetch all case details including digitisationResults

    var config = {
      method: "get",
      url:
        URL.demystify_url + "caseDetails/fetchInitialCase/" + caseId,
      headers: {
        accept: "application/json",
      },
    };

    setLoading(true);

    axios(config)
      .then(function (response) {
        console.log(response.data);
        let res = response.data;
        setDigitisationResults(res["digitization_results"]);
        setName(res["name"]);
        setLabName(res["labName"]);
        setAge(res["age"]);
        setGender(res["gender"]);
        setState(res["status"] || "");
        setDoctorName(res["doctorName"]);
        setRegistrationNum(res["registrationNumber"]);
        setDeclarationAvailable(res["declarationAvailable"]);
        setQualification(res["doctorQualification"]);
        setPhoto(res["photographAvailable"]);
        setApptDate(res["actualAppointmentDate"].split("T")[0]);
        setComment(res["remarks"]);
        setTestList(Array.isArray(res["packageList"]) ? res["packageList"] : JSON.parse(res["packageList"].replace(/'/g, '"')));
        setKeyToDownload(res["key"].split("/")[0].split("_")[0]);
        setRows(res["digitization_results"]);
        setRows2(res["digitization_results"]);
        setProcheckComment(res["comment"]);
        setReportFileType(res["reportContentType"]);
        if (res.hasOwnProperty("lisLabSpcCode")) {
          setLisFlag("Available");
        } else {
          setLisFlag(null);  // or setLisFlag("");
        }
        var data2 = JSON.stringify({
          key: res["key"],
          bucket: res["reportPdfBucket"],
          send_URL: 1,
        });
        var config2 = {
          method: "post",
          url: URL.demystify_url + "caseDetails/fetchBase64pdf/",
          headers: {
            "Content-Type": "application/json",
          },
          data: data2,
        };

        axios(config2)
          .then(function (response) {
            console.log(response.data);
            // setBase64String(response.data);
            setPreSignedUrl(response.data);
            setLoading(false);
          })
          .catch(function (error) {
            alert(error);
            setLoading(false);
            console.log(error);
          });
      })
      .catch(function (error) {
        setLoading(false);
        alert(error);
        console.log(error);
      });
  }, []);

  return (
    <>
      {loading ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <div className="parentContainer">
          <Dialog open={openIncompleteDialog} onClose={handleIncompleteClose}>
            <DialogTitle>Mark as Incomplete</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Do you want to mark this case as incomplete?
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                id="comments"
                label="Comments"
                type="text"
                fullWidth
                variant="standard"
                value={incompleteComments || comment}
                onChange={(event) => setIncompleteComments(event.target.value)}
                required
              />
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleIncompleteClose}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleIncomplete}
              >
                Mark Incomplete
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={openRejectedDialog} onClose={handleRejectedClose}>
            <DialogTitle>Mark as Rejected</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Do you want to mark this case as rejected?
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                id="comments"
                label="Comments"
                type="text"
                fullWidth
                variant="standard"
                value={rejectedCommentsVal}
                onChange={(event) => setRejectedComments(event.target.value)}
                required
              />
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleRejectedClose}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleRejected}
              >
                Mark Rejected
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={openVerifiedDialog} onClose={handleVerifiedClose}>
            <DialogTitle>Mark as Verified</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Do you want to mark this case as verified?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleVerifiedClose}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleVerified}
              >
                Mark Verified
              </Button>
            </DialogActions>
          </Dialog>
          <div className="split left">
            {/* //pdf viewer */}
            <div class="centered">
              <SinglePage
                // base64String={base64String}
                reportFileType={reportFileType}
                preSignedUrl = {preSignedUrl}
                keyToDownload={keyToDownload}
                testPage={testPage}
                setTestPage={setTestPage}
              />
            </div>
          </div>

          <div className="split right">
            <div>
              <div className="firstDivInitial">
                <ArrowCircleLeftIcon
                  sx={{ fontSize: 40, color: "#4095f7" }}
                  className="icon"
                />
                <div className="CaseId">Case ID:</div>
                <div style={{ marginLeft: 5 }}>{caseId}</div>
                {lisFlag && (
                      <>
                          <div className="LisFlagDiv">LIS :</div>
                          <div className="LisFlagValue" style={{ marginLeft: 5 }}>{lisFlag}</div>
                      </>
                  )}
                <DoneIcon
                  sx={{
                    fontSize: 30,
                    color: "#4095f7",
                    marginLeft: 25,
                    border: 1,
                    borderRadius: 2,
                    padding: 0.22,
                  }}
                  className="icon"
                  onClick={handleVerifiedOpen}
                />
                <QuestionMarkIcon
                  sx={{
                    fontSize: 30,
                    color: "#4095f7",
                    marginLeft: 3,
                    border: 1,
                    borderRadius: 2,
                    padding: 0.22,
                  }}
                  className="icon"
                  onClick={handleIncompleteClickOpen}
                />
                <CloseIcon
                  sx={{
                    fontSize: 33,
                    color: "#4095f7",
                    marginLeft: 3,
                    border: 1,
                    borderRadius: 2,
                  }}
                  className="icon"
                  onClick={handleRejectedClickOpen}
                />
                <ModeEditIcon
                  sx={{
                    fontSize: 33,
                    color: "#4095f7",
                    marginLeft: 3,
                    border: 1,
                    borderRadius: 2,
                  }}
                  className="icon"
                  onClick={handleEdit}
                />
              </div>

              <div className="infoDivInitial">
                <div style={{ display: "flex" }}>
                  <div>
                    {" "}
                    <span className="cyan">Name: </span> {name}{" "}
                  </div>
                  <div style={{ marginLeft: 30 }}>
                    {" "}
                    <span className="cyan">Lab Name: </span> {labname}{" "}
                  </div>
                </div>
                <div style={{ display: "flex", marginTop: 5 }}>
                  <div>
                    {" "}
                    <span className="cyan">Age: </span> {age}{" "}
                  </div>
                  <div style={{ marginLeft: 50 }}>
                    {" "}
                    <span className="cyan">Gender: </span> {Gender}{" "}
                  </div>
                  <div style={{ marginLeft: 50 }}>
                    {" "}
                    <span className="cyan">State: </span> {state}{" "}
                  </div>
                </div>
                <div style={{ display: "flex", marginTop: 5 }}>
                  <div>
                    {" "}
                    <span className="cyan">Doctor Name: </span> {doctorName}{" "}
                  </div>
                  <div style={{ marginLeft: 30 }}>
                    {" "}
                    <span className="cyan">Registration Number: </span>{" "}
                    {registrationNum}{" "}
                  </div>
                  <div style={{ marginLeft: 30 }}>
                    {" "}
                    <span className="cyan">Declaration available: </span>{" "}
                    {declarationAvailable}{" "}
                  </div>
                </div>
                <div style={{ display: "flex", marginTop: 5 }}>
                  <div>
                    {" "}
                    <span className="cyan">Doctor Qualification: </span>{" "}
                    {Qualification}{" "}
                  </div>
                  <div style={{ marginLeft: 30 }}>
                    {" "}
                    <span className="cyan">Photograph available: </span> {photo}{" "}
                  </div>
                  <div style={{ marginLeft: 30 }}>
                    {" "}
                    <span className="cyan">Actual appointment date: </span>{" "}
                    {apptDate}{" "}
                  </div>
                </div>
                <div style={{ display: "flex", marginTop: 5 }}>
                  <div>
                    {" "}
                    <span className="cyan">Comments: </span> {comment}{" "}
                  </div>
                </div>
                <div style={{ display: "flex", marginTop: 5 }}>
                    <div className="info-pair">
                      {" "}
                      <span className="cyan">Procheck Comment: </span>{procheckComment}{" "}
                    </div>
                  </div>
              </div>

              <div className="testNamesDiv">
                <span style={{ fontWeight: "bold", marginBottom: 15 }}>
                  Test List:
                </span>
                {testList.map((testName, index) => (
                  <div key={index} className="testListItem">
                    {testName}
                  </div>
                ))}
              </div>

              <CollapsibleTable
                digitisationResults1={digitisationResults}
                caseId={caseId}
                handlePageChange={handlePageChange}
                rows={rows}
                setRows={setRows}
                rows2={rows2}
                setRows2={setRows2}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InitialCaseDetails;
